import { User } from "lucide-react";
import { unixToTimeString } from "../../hooks";
import { formatAssignment } from "../../seating/model";

export default function UserTicketCard({
  activationCode,
  firstName,
  lastName,
  purchaseDate,
  eventData,
  notes,
  seatRow,
  seatCol,
  seatAssignment,
  ...props
}) {
  return (
    <div className="flex flex-col w-full max-w-screen-lg">
      <div id="ticket" className="translate-y-[-85px]"></div>
      <div className="flex flex-col w-full items-center justify-center gap-4 pt-[78px] mt-[-78px]">
        {/* {eventData?.events?.vendorType > vendorTier.BASIC ? (
          <div className="flex flex-col bg-blue-100 rounded-2xl px-4 py-2 divide-y-2 divide-slate-500 border-2 border-blue-200 w-full gap-2">
            <div className="flex flex-col w-full justify-center items-center gap-2">
              <h1 className="text-lg text-blue-800 font-bold tracking-normal">
                Here is your eCard information
              </h1>
              <p className="text-xs text-blue-800 font-normal">
                This event is eCard enabled. Please use your ticket QR code as your eCard. You may need to provide the following information during the event.
              </p>
            </div>
            <div className="flex flex-row justify-between items-center pt-2">
              <h1 className="text-sm text-slate-600 font-semibold">
                Card Number
              </h1>
              <h1 className="text-sm text-slate-600 font-mono">
                {cardInfo?.cardID || "Unknown Card Number"}
              </h1>
            </div>
            <div className="flex flex-row justify-between items-center pt-2">
              <h1 className="text-sm text-slate-600 font-semibold">
                Security (CVV)
              </h1>
              <h1 className="text-sm text-slate-600 font-mono">
                {cardInfo?.security || "Unknown Security Code"}
              </h1>
            </div>
          </div>
        ) : null} */}

        <div className="flex flex-col md:flex-row w-full gap-4 p-2 md:p-8 md:pr-10 border-2 border-slate-400 rounded-xl">
          <div className="flex flex-col items-center md:items-start w-full md:w-[238px] shrink-0 gap-4">
            <img
              src={"https://qr.endevre.com?e=advent&code=TICK" + activationCode}
              className="max-w-[350px] max-h-[350px] w-full object-fit bg-white border border-slate-100 rounded-xl aspect-square shrink-0"
              alt="Activation QR Code"
            />
            <div className="flex flex-col w-full p-4 bg-slate-50 border border-slate-100 rounded-xl gap-2 justify-center items-center">
              <h1 className="text-base text-slate-800 font-bold tracking-normal">
                Confirmation Code
              </h1>
              <p className="text-sm text-slate-800 font-mono">
                TICK{activationCode}
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-4 w-full">
            <div className="flex flex-row items-center w-full p-4 bg-slate-50 border border-slate-100 rounded-xl gap-2">
              <User className="w-5 h-5 text-slate-800" />
              <h1 className="text-lg text-slate-800 font-bold tracking-normal">
                {firstName + " " + lastName}
              </h1>
            </div>

            <div className="flex flex-col bg-slate-50 rounded-2xl px-4 py-2 divide-y divide-black border-2 border-slate-100 w-full gap-2">
              {/* <div className="flex flex-row justify-between items-center pt-2">
                <h1 className="text-sm text-slate-600 font-semibold">
                  Name
                </h1>
                <h1 className="text-sm text-slate-600 font-mono">
                  {firstName + " " + lastName}
                </h1>
              </div> */}
              {(seatAssignment?.seatMessage || seatAssignment?.seatID || (seatRow && seatCol)) && (
                <div className="flex flex-row justify-between items-center pt-2">
                  <h1 className="text-sm text-slate-600 font-semibold">
                    Seat Information
                  </h1>
                  <h1 className="text-sm text-slate-600 font-mono">
                    {formatAssignment(seatAssignment, seatRow, seatCol)}
                  </h1>
                </div>
              )}
              <div className="flex flex-row justify-between items-center pt-2">
                <h1 className="text-sm text-slate-600 font-semibold">
                  Date Purchased
                </h1>
                <h1 className="text-sm text-slate-600 font-mono">
                  {unixToTimeString(purchaseDate, "", "LLL dd, yyyy, hh:mm a")}
                </h1>
              </div>
              <div className="flex flex-row justify-between items-center pt-2">
                <h1 className="text-sm text-slate-600 font-semibold">
                  Event Start Date
                </h1>
                <h1 className="text-sm text-slate-600 font-mono">
                  {unixToTimeString(
                    eventData?.timeStart,
                    eventData?.timeZone,
                    "LLL dd, yyyy, hh:mm a"
                  )}
                </h1>
              </div>
              <div className="flex flex-row justify-between items-center pt-2">
                <h1 className="text-sm text-slate-600 font-semibold">
                  Event End Date
                </h1>
                <h1 className="text-sm text-slate-600 font-mono">
                  {unixToTimeString(
                    eventData?.timeEnd,
                    eventData?.timeZone,
                    "LLL dd, yyyy, hh:mm a"
                  )}
                </h1>
              </div>
              <div className="flex flex-row justify-between items-center pt-2">
                <h1 className="text-sm text-slate-600 font-semibold">
                  Event Location
                </h1>
                <h1 className="text-sm text-slate-600 font-mono">
                  {eventData?.address || "Unknown Location"}
                </h1>
              </div>
            </div>

            <div className="flex flex-col w-full p-4 bg-slate-50 border-2 border-slate-100 rounded-xl gap-2">
              <h2 className="text-md font-bold text-slate-800">
                Additional notes from the event organizer
              </h2>
              <p className="text-sm font-normal text-slate-800">
                {notes ? notes : "No additional notes"}
              </p>
            </div>
          </div>
        </div>

        {/* <div className="flex flex-col w-full p-4 bg-slate-50 border-2 border-slate-100 rounded-xl gap-2">
          <h2 className="text-md font-bold text-slate-800">
            Additional notes from the event organizer
          </h2>
          <p className="text-sm font-normal text-slate-800">
            {notes? notes : "No additional notes"}
          </p>
        </div> */}
      </div>
    </div>
  );
}
